import { GraphQLClient, Variables } from 'graphql-request';

import getConfig from '../../src/temp/config';

type ErrorPolicy = 'none' | 'ignore' | 'all';

export interface NextFetchOptions {
  revalidate?: number | false;
  tags?: string[];
  cache?: RequestCache;
}

export const executeGQLQuery = async <T = unknown>(
  query: string,
  variables: Variables,
  errorPolicy: ErrorPolicy = 'none',
  nextOptions?: NextFetchOptions
): Promise<T> => {
  const config = getConfig();

  const customFetch = (input: RequestInfo | URL | string, init?: RequestInit) => {
    const { cache, ...nextOnlyOptions } = nextOptions ?? {};
    return fetch(input, {
      ...init,
      ...(nextOptions && { cache, next: nextOnlyOptions }),
    } as RequestInit);
  };

  const client = new GraphQLClient(config.graphQLEndpoint, {
    fetch: customFetch,
    errorPolicy,
  });
  client.setHeader('sc_apikey', config.sitecoreApiKey);

  // Use rawRequest when errorPolicy is 'all' to access errors
  if (errorPolicy === 'all') {
    const { data, errors = [] } = await client.rawRequest<T>(query, variables);

    if (errors.length > 0) {
      const yellow = '\x1b[33m';
      const reset = '\x1b[0m';
      console.warn(`${yellow}Warning ${reset}GraphQL returned errors:`, errors);
    }

    return data;
  }

  return await client.request(query, variables);
};
